module.exports = __webpack_public_path__ + "img/plan-select.965e3665.svg";